import { useState, useEffect } from 'react';
import { trackPlaylistAdd } from '../utils/analytics';

export const usePlaylist = () => {
  const [currentPlaylist, setCurrentPlaylist] = useState([]);

  // Load playlist from localStorage on mount
  useEffect(() => {
    const savedPlaylist = localStorage.getItem('podcastPlaylist');
    if (savedPlaylist) {
      try {
        const parsed = JSON.parse(savedPlaylist);
        setCurrentPlaylist(parsed);
      } catch (error) {
        console.error('Error loading playlist from localStorage:', error);
      }
    }
  }, []);

  // Save playlist to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('podcastPlaylist', JSON.stringify(currentPlaylist));
  }, [currentPlaylist]);

  const addToPlaylist = (podcast) => {
    setCurrentPlaylist(prev => {
      // Check if podcast is already in playlist
      if (prev.some(item => item.id === podcast.id)) {
        return prev; // Don't add duplicates
      }
      // Track playlist addition
      trackPlaylistAdd(podcast.id, podcast.title);
      return [...prev, podcast];
    });
  };

  const removeFromPlaylist = (podcastId) => {
    setCurrentPlaylist(prev => 
      prev.filter(podcast => podcast.id !== podcastId)
    );
  };

  const clearPlaylist = () => {
    setCurrentPlaylist([]);
  };

  const moveInPlaylist = (fromIndex, toIndex) => {
    setCurrentPlaylist(prev => {
      const newPlaylist = [...prev];
      const [movedItem] = newPlaylist.splice(fromIndex, 1);
      newPlaylist.splice(toIndex, 0, movedItem);
      return newPlaylist;
    });
  };

  const isInPlaylist = (podcastId) => {
    return currentPlaylist.some(podcast => podcast.id === podcastId);
  };

  return {
    currentPlaylist,
    addToPlaylist,
    removeFromPlaylist,
    clearPlaylist,
    moveInPlaylist,
    isInPlaylist
  };
};